module.exports = __webpack_public_path__ + "img/c-2.d10c19ae.png";